<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
// import Select from "@/components/c-select";
// import { propertyService } from "../../../services/propertyservice/property.service";
import { propertyhandoverService } from "../../../services/propertyservice/propertyhandover.service";
// import { saleService } from "../../../services/saleservice/sale.service";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Property Handover",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    Button,
    Input,
    Area,
    // Select
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      breadCrumb: {},
      handoverData: {},
      handoverStatus: 0,
      bankAccountData: [],
      user: JSON.parse(localStorage.getItem('user')),
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueProperty: '',
      valueProject: '',
      valueSale: '',
      valueBooking: '',
      valueTotal: 0,
      valueNotation: '',
    };
      
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);    
    // } else if('saleid' in this.$route.query) {
    //   this.loadingSaleById(this.$route.query.saleid);
    } else {
      this.loadingData(0);     
    }

  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyhandoverService.getProperty(id)
        .then(response => {
          if(response.data) {
            this.breadCrumb = {
              text: response.data.code,
              active: true,
            };

            this.fetchingStats = true;
            this.loading(response);

          }

          this.loadingSettings(response.setting);
          
        });
    },

    loadingSettings: function(setting) {

      this.handoverData = {data: setting.handovers};
      this.handoverStatus = setting.handovers ? setting.handovers.property_handover_status_id : 0;

      console.log(JSON.stringify(this.handoverData));
    },

    allowToRequest() {
      return this.handoverStatus == 0 ||  this.handoverStatus == 3 ? true : false;
    },

    getRequestStatus() {
      return this.handoverStatus == 1 ? 'កំពុងដាក់សំណើរ' : 
                this.handoverStatus == 2 ? 'បានអនុម័ត' : '';
    },

    // loadingSaleById: function(id) {

    //   this.fetchingStats = false;
    //   saleService.getSaleByProperty(id)
    //     .then(response => {

    //       if(response.data) {
    //         this.breadCrumb = {
    //           text: response.data.code,
    //           active: true,
    //         };
            
    //         this.fetchingStats = true;
    //         this.loading(response);
            

    //       }

    //       this.loadingSettings(response.setting);
    //     });
    // },

    loading: function(response) {

      // console.log(JSON.stringify(response));

      this.propertyData = response;
      this.valueProperty = this.propertyData.data.code;
      this.valueProject = this.propertyData.data.project_id;
      this.valueSale = this.propertyData.data.sale;
      this.valueTotal = this.propertyData.data.total_paid;
      this.valueNotation = '';
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },

    submitSave: function() {

      console.log(this.valueProject);

      this.tryingToSubmit = true;

      let obj = {
       
        property_id: this.propertyData.data.id,
        sale_id: this.propertyData.data.sale_id,
        notation: this.valueNotation,
        property_handover_status_id: 1,
        handover_date: this.valueDate,
        project_id: this.valueProject,

      };

      console.log(JSON.stringify(obj));
      propertyhandoverService.insert(obj)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {
          this.$router.push(this.$route.query.redirectFrom || {
            name: "property-list"
          });

          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message-edit'),
            icon: "success",
            confirmButtonText: i18n.t('general.ok')
          });

        }
      });

      
    },

    clearForm: function() {
      this.valueDate = this.$moment().clone().format('YYYY-MM-DD'),
      this.valueProperty = '';
      this.valueSale = '';
      this.valueBooking = '';
      this.valueTotal = 0;
      this.valueRefund = 0;
      this.valueNotation = "";
    },
  }
};
</script>

<template>
  <Layout>

    <PageHeader :items="[{
      text: $t('property.text'),
      href: '/general/property',
    }, this.breadCrumb]" :title="$t('property.handover.request') + ' '+ $t('property.handover.text') " />

    
    <Loader :loading="fetchingStats">
    <div class="row">
      <b-form class="row">
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'date'"
                    :id="'for_date'"
                    v-model="valueDate"
                    :label="'property.cancelation.date'" 
                  /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'property_id'"
                    v-model="valueProperty"
                    :disabled="true"
                    :label="'property.text'" 
                  /> 
                </div>
              </div>
              <div class="row">
                
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'sale_id'"
                    v-model="valueSale"
                    :disabled="true"
                    :label="'property.cancelation.sale'" 
                  /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'total'"
                    :disabled="true"
                    v-model="valueTotal"
                    :last="'USD'"
                    :label="'property.cancelation.total'" 
                  /> 
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Area 
                    :rows="7"
                    :id="'block_note'"
                    v-model="valueNotation"
                    :label="'property.cancelation.notation'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-form inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto" v-show="allowToRequest()">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </b-form>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-lg-4" v-show="!allowToRequest()">
          <div style="width: '100%'; height: 60px; background-color: coral; border-radius: 15px; margin: auto; text-align: center;">
            <p style="font-size: 18pt; line-height: 60px; color: white;">{{getRequestStatus()}}</p>
          </div>
        </div>
      </b-form>
    </div>    
    </Loader>
  </Layout>
</template>